import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface ICreationFormMeta {
    date: FormInputMeta;
    BINDestination: FormInputMeta;
    message: FormInputMeta;
    unknown1: FormInputMeta;
    //
    schema: any;
  }

const CreationFormMeta = {} as ICreationFormMeta;

CreationFormMeta.date = {
  name: 'date',
  type: 'date',
  label: 'Date d\'evenement',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
CreationFormMeta.BINDestination = {
  name: 'BINDestination',
  type: 'text',
  label: 'Destination BIN',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
CreationFormMeta.message = {
  name: 'message',
  type: 'text',
  label: 'Message',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
CreationFormMeta.unknown1 = {
  name: "unknown1",
  type: "text",
  label: "_",
  placeholder: "",
  validation: yup.string(),
};


CreationFormMeta.schema = yup.object().shape(getValidationSchema(CreationFormMeta));

export default CreationFormMeta;
